import React from "react";
import { ContentGrid, Grid2, Grid3 } from "../styles";
import { Card, Button, Field, Toggle, Pill } from "../components";
import Icon from "../components/Icon";

const ComplianceView = ({ kycStatus, riskTier, setRiskTier, pep, setPep, sourceFunds, setSourceFunds, pushToast, uid, setAudit }) => {
  return (
    <ContentGrid>
      <Card title="Compliance View" icon="shield" right={<Pill tone="d">KYC/KYB • PEP • SoF • Limits</Pill>}>
        <ContentGrid>
          <Grid2>
            <div style={{ borderRadius: 16, border: "1px solid rgba(92,233,255,.12)", background: "rgba(0,0,0,.20)", padding: 12, display: "grid", gap: 10 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                <div style={{ fontWeight: 900 }}>KYC status</div>
                <Pill tone={kycStatus === "approved" ? "d" : kycStatus === "pending" ? "c" : "b"}>{kycStatus}</Pill>
              </div>
              <ContentGrid>
                <ContentGrid>
                  <div style={{ fontSize: 12, color: "rgba(210,235,245,.78)", fontWeight: 900 }}>Risk tier</div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {(["low", "medium", "high", "very_high"]).map((t) => (
                      <button
                        key={t}
                        onClick={() => {
                          setRiskTier(t);
                          pushToast("Compliance", "Risk tier set to " + t.replace("_", " "));
                          setAudit((s) => [{ id: uid(), ts: "2026-01-08 08:56", actor: "user", type: "Compliance", detail: "Risk tier changed: " + t, severity: "med" }, ...s]);
                        }}
                        style={{
                          padding: "8px 10px",
                          borderRadius: 999,
                          border: "1px solid rgba(92,233,255,.12)",
                          background: riskTier === t ? "linear-gradient(90deg, rgba(92,233,255,.22), rgba(0,247,210,.12))" : "rgba(255,255,255,.04)",
                          color: "rgba(240,250,255,.92)",
                          cursor: "pointer",
                          fontWeight: 900,
                          fontSize: 12,
                        }}
                      >
                        {t.replace("_", " ")}
                      </button>
                    ))}
                  </div>
                </ContentGrid>

                <Toggle label="PEP flag" checked={pep} onChange={setPep} hint="Politically Exposed Person" />
              </ContentGrid>
            </div>

            <div style={{ borderRadius: 16, border: "1px solid rgba(92,233,255,.12)", background: "rgba(0,0,0,.20)", padding: 12, display: "grid", gap: 10 }}>
              <div style={{ fontWeight: 900 }}>Source of Funds</div>
              <Field label="Declaration" value={sourceFunds} onChange={setSourceFunds} placeholder="e.g., Salary / Business revenue" />
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", flexWrap: "wrap" }}>
                <Button
                  variant="sec"
                  onClick={() => {
                    pushToast("Compliance", "Document request sent (demo)");
                    setAudit((s) => [{ id: uid(), ts: "2026-01-08 08:57", actor: "system", type: "Compliance", detail: "SoF document request issued", severity: "med" }, ...s]);
                  }}
                >
                  Request proof
                </Button>
                <Button
                  onClick={() => {
                    pushToast("Compliance", "Compliance data saved");
                    setAudit((s) => [{ id: uid(), ts: "2026-01-08 08:58", actor: "user", type: "Compliance", detail: "Compliance profile updated", severity: "low" }, ...s]);
                  }}
                  icon="check"
                >
                  Save
                </Button>
              </div>
            </div>
          </Grid2>

          <Grid3>
            <Card title="Limits" icon="shield">
              <ContentGrid>
                <Pill>Daily: €25,000</Pill>
                <Pill tone="c">Monthly: €250,000</Pill>
                <Pill tone="d">Tier-based</Pill>
              </ContentGrid>
            </Card>
            <Card title="Monitoring" icon="log">
              <ContentGrid>
                <Pill tone="c">AML rules: active</Pill>
                <Pill tone="d">Sanctions: screened</Pill>
                <Pill tone="b">Alerts: escalations</Pill>
              </ContentGrid>
            </Card>
            <Card title="Evidence" icon="key">
              <ContentGrid>
                <Button variant="sec" onClick={() => pushToast("Evidence", "Upload module goes here")}>Upload docs</Button>
                <Button variant="sec" onClick={() => pushToast("Evidence", "Proofs linked to audit (demo)")}>Link to audit</Button>
              </ContentGrid>
            </Card>
          </Grid3>
        </ContentGrid>
      </Card>
    </ContentGrid>
  );
};

export default ComplianceView;
